import { render, staticRenderFns } from "./PdfFormFieldsModal.vue?vue&type=template&id=70e3eca7&scoped=true"
import script from "./PdfFormFieldsModal.vue?vue&type=script&lang=js"
export * from "./PdfFormFieldsModal.vue?vue&type=script&lang=js"
import style0 from "./PdfFormFieldsModal.vue?vue&type=style&index=0&id=70e3eca7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e3eca7",
  null
  
)

export default component.exports